<mat-card>
    <mat-card-content>
        <mat-card-title>Alarm Pegawai</mat-card-title>
        <mat-card-subtitle>
        </mat-card-subtitle>

        <div fxLayout="row wrap" style="margin-bottom: 20px;">
            <div class="spacer"></div>
            <div fxFlex.gt-lg="30" fxFlex.gt-md="30" fxFlex.gt-xs="100" fxFlex="100">
                <mat-form-field class="filter-form" appearance="outline">
                    <mat-label>Tipe</mat-label>
                    <mat-select [(ngModel)]="type">
                        <mat-option *ngFor="let p of types" [value]="p.id">
                            {{ p.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div fxFlex.gt-lg="20" fxFlex.gt-md="20" fxFlex.gt-xs="100" fxFlex="100">
                <input matInput placeholder="Cari..." [(ngModel)]="searchTerm" class="search-field input-outline" />
            </div>

            <div>
                <button mat-raised-button color="primary" (click)="search()">
                    Cari
                </button>
            </div>
        </div>
        <div fxLayout="row wrap">
            <div *ngIf="dataSource.length === 0" class="center-col">Tidak ada notifikasi</div>
            <table mat-table [dataSource]="dataSource" class="full-width">
                <ng-container matColumnDef="username">
                    <th mat-header-cell *matHeaderCellDef>NIP</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.username }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>Nama</th>
                    <td mat-cell *matCellDef="let element"><a href="#" [routerLink]="['/profile/' + element.id]">{{
                            element.fullname
                            }}</a></td>
                </ng-container>

                <ng-container matColumnDef="substansi">
                    <th mat-header-cell *matHeaderCellDef>Substansi</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.substansi }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="bup">
                    <th mat-header-cell *matHeaderCellDef>BUP</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.bup }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="kenpa">
                    <th mat-header-cell *matHeaderCellDef>Kenpa</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.kenpa }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="kgb">
                    <th mat-header-cell *matHeaderCellDef>KGB</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.kgb }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </div>
        <div fxLayout="row wrap">
            <mat-paginator #paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                (page)="reload($event)">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>